export default __webpack_public_path__ + "static/media/3.114fa0db.png";